import { Storage } from '@dvs-angular/storage';

export class TokenProvider {

  constructor(
    private tokenName: string,
    private storage: Storage
  ) {}

  public getToken(): string {
    return this.storage.get(this.tokenName);
  }

  public setToken(token: string): void {
    this.storage.set(this.tokenName, token);
  }

  public removeToken(): void {
    this.storage.delete(this.tokenName);
  }
}
